export const handleContextLoss = (event, gl: HTMLCanvasElement) => {
  event.preventDefault()

  // Cleanup operations (if needed)
  // For example, clear resources, buffers, and shaders

  const ctx = gl.getContext('webgl2')
  if (!ctx) {
    console.error('Failed to restore WebGL context')
  } else {
    console.log('WebGL context restored successfully')
  }
}
